import { ApplicationTypes, BoltHole, attachComponent, featureLabels } from 'metalworks-domain'

import {
  detailComponent,
  distanceDimensionComponent,
  entityHeaderComponent,
  propertyPageComponent,
} from '@salsita-ai/platform-project-sdk/domain'
import { DeleteEntityButton } from '@salsita-ai/platform-project-sdk/react'

import { HolePropertyPage } from '../ui/property-pages/HolePropertyPage'

export const boltHoleComponents = [
  // TODO: yaml
  attachComponent
    .withComponent(detailComponent, 'main')
    .withEntity('BoltHole')
    .attach(() => {
      return {
        title: featureLabels[BoltHole.type],
        subtitle: 'Single bolt hole with adjustable diameter.',
        description: 'You can position the hole around the plate.',
        thumbnailUrl: '/thumbnails/circular-hole.png',
      }
    }),
  attachComponent
    .withComponent(propertyPageComponent, 'box')
    .withEntity('BoltHole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      page: <HolePropertyPage id={s.id} />,
    })),
  // TODO: memoEval
  attachComponent
    .withComponent(entityHeaderComponent, 'main')
    .withEntity('BoltHole')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    .attach(s => ({
      secondaryButton: <DeleteEntityButton entityId={s.id} />,
    })),
  // TODO: yaml
  attachComponent
    .withComponent(distanceDimensionComponent, 'diameter')
    .withEntity('BoltHole')
    .attach(
      s => ({
        value: s.radius * 2,
        min: 0.5,
        max: Math.min(20, s.$plate.$maxFeatureSize.x, s.$plate.$maxFeatureSize.y),
        unit: 'mm',
      }),
      v => {
        // TODO: can this be diameter - it will not be possible to migrate to yaml
        return {
          radius: v.value / 2,
        }
      }
    ),
]
